import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography
} from "@mui/material";
import axios from "axios";
import { REST_API_END_POINT, FacilityTypes } from "src/constants/Defaultvalues";
import moment from "moment";
import { Container, Stack } from "@material-ui/core";

const data = [
  {
    datetime: "2026-04-13 10:30 AM",
    cost: 1200,
    user: "John Doe"
  },
  {
    datetime: "2026-04-13 11:15 AM",
    cost: 950,
    user: "Jane Smith"
  },
  {
    datetime: "2026-04-13 12:45 PM",
    cost: 1500,
    user: "Alex"
  }
];

export default function QbStockLog({quickbookId}) {
  const [stockPriceLog,setStockPriceLog] = useState([])

  const fetchAllQbStockPriceLog =async () =>{
    try {
      const res =await axios.post(`${REST_API_END_POINT}products/get-all-qb-stock-price-log`,{quickbookId})
      if(res.data.status ==1){
        setStockPriceLog(res.data.result)
      }else{
        setStockPriceLog([])
      }
    } catch (error) {
      console.log("error",error)
      setStockPriceLog([])
    }
  }
  useEffect(()=>{
    fetchAllQbStockPriceLog()
  },[quickbookId])
  return (
    <Container>
      <Stack sx={{p:10}}>
    <TableContainer component={Paper} sx={{paddding:20}}>
      {/* <Typography variant="h6" sx={{ padding: 2, mb: 4 }}   >
        Purchase History
      </Typography> */}

      <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>Date / Time</strong></TableCell>
            <TableCell><strong>QB Purchase Cost</strong></TableCell>
            <TableCell><strong>QB Sales Price</strong></TableCell>
            <TableCell><strong>User</strong></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {(stockPriceLog || [])?.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{moment.unix(row.timestamp).format('DD-MM-YYYY HH:mm')}</TableCell>
              <TableCell> {row.qb_purchase_cost ? `$ ${row.qb_purchase_cost}` : '-'}</TableCell>
              <TableCell> {row.qb_sales_price ? `$ ${row.qb_sales_price}` : '-'}</TableCell>
              <TableCell>
                {row.userName ||
                  (row.from_facility != null &&
                  row.from_facility !== ''
                    ? FacilityTypes.find((f) => Number(f.id) === Number(row.from_facility))
                        ?.label || `Facility ${row.from_facility}`
                    : '-')}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Stack>
    </Container>
  );
}